import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const TOKEN_KEY = "aql_admin_token";

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

api.interceptors.request.use((config) => {
  const t = getToken();
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      // Token bad/expired — drop it. The AdminGate listens and will re-prompt.
      const had = getToken();
      if (had) {
        clearToken();
        window.dispatchEvent(new Event("aql:auth-changed"));
      }
    }
    return Promise.reject(err);
  }
);

export const adminLogin = (passcode) =>
  api.post("/auth/login", { passcode }).then((r) => r.data);

export const adminMe = () => api.get("/auth/me").then((r) => r.data);

export const createInquiry = (payload) =>
  api.post("/inquiries", payload).then((r) => r.data);

export const listInquiries = (status) =>
  api.get("/inquiries", { params: status ? { status } : {} }).then((r) => r.data);

export const updateInquiryStatus = (id, status) =>
  api.patch(`/inquiries/${id}`, { status }).then((r) => r.data);

export const deleteInquiry = (id) =>
  api.delete(`/inquiries/${id}`).then((r) => r.data);

export const listGallery = (includeInactive = false) =>
  api
    .get("/gallery", { params: includeInactive ? { include_inactive: true } : {} })
    .then((r) => r.data);

export const createGalleryItem = (payload) =>
  api.post("/gallery", payload).then((r) => r.data);

export const updateGalleryItem = (id, payload) =>
  api.patch(`/gallery/${id}`, payload).then((r) => r.data);

export const deleteGalleryItem = (id) =>
  api.delete(`/gallery/${id}`).then((r) => r.data);

export const getStats = () => api.get("/inquiries/stats").then((r) => r.data);
